import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { BorderRadiusProps } from 'styled-system';
import {
  backgroundColor,
  borderRadius,
  bottom,
  left,
  position,
  right,
  top,
  zIndex,
} from 'styled-system';

import { Flex } from './components/Flex';
import Spinner from './components/Spinner';
import { OVERLAY_Z_INDEX } from './constants/z-index';

const LOADING_ICON_SIZE = [24, 28, null, 32];

const UnstyledOverlay = styled(Flex)<any>`
  ${backgroundColor};
  ${position};
  ${top};
  ${bottom};
  ${right};
  ${left};
  ${zIndex};
  ${borderRadius};
`;

const Overlay = (props: ComponentProps<typeof UnstyledOverlay>) => (
  <UnstyledOverlay
    backgroundColor="rgba(255, 255, 255, 0.8)"
    position="absolute"
    top={0}
    right={0}
    left={0}
    bottom={0}
    justifyContent="center"
    alignItems="center"
    zIndex={OVERLAY_Z_INDEX}
    {...props}
  />
);

const OverlayLoader = ({
  showSpinner = true,
  ...customProps
}: { showSpinner?: boolean } & BorderRadiusProps) => (
  <Overlay data-testid="overlay" {...customProps}>
    {showSpinner && <Spinner size={LOADING_ICON_SIZE} strokeColor="sys.neutral.border.hover" />}
  </Overlay>
);
export default OverlayLoader;
